module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "old-poll"
    }
  }, [_vm._l((_vm.oldPolls.rows), function(poll) {
    return [(!poll.hasImage) ? [_c('div', {
      staticClass: "box-poll"
    }, [_c('div', {
      staticClass: "topic"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(poll.topic) + "\n\t\t\t\t")]), _vm._v(" "), _vm._l((poll.choices), function(choice) {
      return [_c('div', {
        staticClass: "choice dash-bg-color-skin-light-10"
      }, [_c('div', {
        staticClass: "progress dash-bg-color-skin-dark-10",
        style: ({
          width: _vm.progressPercent(choice.number, poll.totalVote)
        })
      }), _vm._v(" "), _c('div', {
        staticClass: "choosentext"
      }, [_c('div', {
        staticClass: "choose-space"
      }, [_c('i', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (choice.selected),
          expression: "choice.selected"
        }],
        staticClass: "fa fa-check"
      })]), _vm._v(" "), _c('div', {
        staticClass: "text"
      }, [_vm._v(_vm._s(choice.text))]), _vm._v(" "), _c('div', {
        staticClass: "number"
      }, [_vm._v(_vm._s(choice.number))])])])]
    }), _vm._v(" "), _c('div', {
      staticClass: "date-box"
    }, [_c('i', {
      staticClass: "fa fa-thumbs-o-up like",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "total-vote"
    }, [_vm._v(_vm._s(poll.totalVote))]), _vm._v(" "), _c('div', {
      staticClass: "date-poll"
    }, [_vm._v(_vm._s(poll.dtestrt) + " - " + _vm._s(poll.dteend))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-clock-o clock",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 2)] : [_c('div', {
      staticClass: "box-poll-pic"
    }, [_c('div', {
      staticClass: "topic"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(poll.topic) + "\n\t\t\t\t")]), _vm._v(" "), _vm._l((poll.choices), function(choice) {
      return [_c('div', {
        staticClass: "choice-img"
      }, [_c('div', {
        staticClass: "set-img"
      }, [(choice.image) ? [_c('img', {
        staticClass: "img-circle",
        attrs: {
          "src": _vm.baseURL + _vm.filePath.load + choice.image
        }
      })] : [_c('img', {
        staticClass: "img-circle",
        attrs: {
          "src": require("static/images/employee/no_image.png")
        }
      })]], 2), _vm._v(" "), _c('div', {
        staticClass: "progress-bg dash-bg-color-skin-light-10"
      }, [_c('div', {
        staticClass: "progress dash-bg-color-skin-dark-10",
        style: ({
          width: _vm.progressPercent(choice.number, poll.totalVote)
        })
      }), _vm._v(" "), _c('div', {
        staticClass: "choosentext"
      }, [_c('div', {
        staticClass: "choose-space"
      }, [_c('i', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (choice.selected === 'Y'),
          expression: "choice.selected === 'Y'"
        }],
        staticClass: "fa fa-check"
      })]), _vm._v(" "), _c('div', {
        staticClass: "text"
      }, [_vm._v(_vm._s(choice.text))]), _vm._v(" "), _c('div', {
        staticClass: "number"
      }, [_vm._v(_vm._s(choice.number))])])])])]
    }), _vm._v(" "), _c('div', {
      staticClass: "date-box"
    }, [_c('i', {
      staticClass: "fa fa-thumbs-o-up like",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "total-vote"
    }, [_vm._v(_vm._s(poll.totalVote))]), _vm._v(" "), _c('div', {
      staticClass: "date-poll"
    }, [_vm._v(_vm._s(poll.dtestrt) + " - " + _vm._s(poll.dteend))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-clock-o clock",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 2)]]
  }), _vm._v(" "), (_vm.triggerOldPollInfiniteBool) ? _c('hrms-infinite-loading', {
    ref: "oldPollsLoading",
    on: {
      "infinite": _vm.onInfinite
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c2b0426!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/poll/oldPoll.vue
// module id = 3542
// module chunks = 1